import { motion } from "framer-motion";
import { ASSETS } from "../lib/data";
import { useT } from "../lib/i18n";
import { MustacheMark } from "./MustacheMark";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export const Story = () => {
  const { t } = useT();
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-black text-white py-24 md:py-40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-12 gap-8 md:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="col-span-12 md:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={ASSETS.kioskSide}
              alt="Monsieur Toast kiosk side view"
              className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-1000 ease-out"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/20" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:flex items-center gap-3 bg-black border border-gold/30 px-5 py-3">
            <MustacheMark className="h-4 w-auto" color="#D4A857" />
            <span className="text-[10px] tracking-[0.35em] uppercase text-gold">
              {t("story.badge")}
            </span>
          </div>
        </motion.div>

        <motion.div
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.1 } } }}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-20%" }}
          className="col-span-12 md:col-span-6 md:col-start-7"
        >
          <motion.span
            variants={fadeUp}
            className="text-[11px] tracking-[0.4em] uppercase text-gold"
          >
            {t("story.kicker")}
          </motion.span>

          <motion.h2
            variants={fadeUp}
            data-testid="story-heading"
            className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            {t("story.heading.1")}{" "}
            <span className="italic text-gold">{t("story.heading.france")}</span>,
            <br />
            {t("story.heading.2")}
          </motion.h2>

          <motion.p
            variants={fadeUp}
            className="mt-8 text-white/70 text-base md:text-lg font-light leading-[1.8] max-w-xl"
          >
            {t("story.body.1")}{" "}
            <em className="text-gold not-italic">{t("story.body.croque")}</em>
            {t("story.body.2")}
          </motion.p>

          <motion.p
            variants={fadeUp}
            className="mt-5 text-white/60 text-base md:text-lg font-light leading-[1.8] max-w-xl"
          >
            {t("story.body.3")}
          </motion.p>

          <motion.div
            variants={fadeUp}
            className="mt-10 grid grid-cols-3 gap-6 max-w-md border-t border-gold/15 pt-8"
          >
            <div data-testid="stat-bread">
              <div className="font-display text-3xl md:text-4xl text-gold">12h</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-white/50">
                {t("story.stat.bread")}
              </div>
            </div>
            <div data-testid="stat-cheese">
              <div className="font-display text-3xl md:text-4xl text-gold">100%</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-white/50">
                {t("story.stat.cheese")}
              </div>
            </div>
            <div data-testid="stat-craft">
              <div className="font-display text-3xl md:text-4xl text-gold">1×1</div>
              <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-white/50">
                {t("story.stat.craft")}
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Story;
